import React, { useContext, useState } from "react";
import uiContext from "../context/ui/uiContext";
import { ToastContainer, toast } from "react-toastify";
// import ReactHtmlParser from "react-html-parser";

function TextEditor(props) {
    const context=useContext(uiContext);
    const {dataContext,setDataContext}=context;
  const [data, setData] = useState({
    title: "",
    category: "general",
    imglink: "",
    slug: "",
    article: "",
  });
  const handlechange = (e) => {
    setData((prev)=>{
        return {...prev,[e.target.name]:e.target.value}
    })
    setDataContext(data);
  };

  const handleSubmit=async()=>{
      const response=await fetch(`${process.env.REACT_APP_API_URL}blog/addblog`,{
          method:"POST",
          headers:{
              "Content-Type":"application/json",
              "auth-token":localStorage.getItem("auth-token")
          },
          body:JSON.stringify(dataContext)
      })
      const result=await response.json();
      if (!result.success) {
          return toast.error("Not Uploaded, Enter Valid Data");
      }
      console.log(dataContext);
      toast.success("Uploaded");
      setDataContext({
        title: "",
        category: "general",
        imglink: "",
        slug: "",
        article: "",
      });
      setData({
        title: "",
        category: "general",
        imglink: "",
        slug: "",
        article: "",
      });
      
  }
  return (
    <>
    <ToastContainer/>
      <div class="formblock">
        <div className="formControl">
          <label>Title</label>
          <input type="text" name="title" onChange={handlechange} value={data.title} maxlength="150"></input>
        </div>
        <div className="formControl">
          <label>Category</label>
          <select onChange={handlechange} value={data.category} name="category">
            <option value="general" selected>
              General
            </option>
            <option value="technology">Technology</option>
            <option value="sports">Sports</option>
            <option value="health">Health</option>
            <option value="movies">Movies</option>
            <option value="bio">Bio</option>
          </select>
        </div>

        <div className="formControl">
          <label>Cover Image Link</label>
          <input type="text" onChange={handlechange} value={data.imglink} name="imglink"></input>
        </div>
        <div className="formControl">
          <label>Slug Url</label>
          <input type="text" onChange={handlechange} value={data.slug} name="slug"></input>
        </div>
        <div className="formControl myeditor">
          <label>Article</label>
          <textarea
            type="text"
            onChange={handlechange}
            value={data.article}
            name="article"
          ></textarea>
        </div>
        <button className="submitbtn" onClick={handleSubmit}>Submit</button>
      </div>
      
    </>
  );
}

export default TextEditor;
